module.exports = __webpack_public_path__ + "img/niño54.bc135f76.jpg";